// src/api/api.js
import axios from "axios";

// Buat instance axios dengan baseURL dari .env
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor REQUEST
// Sebelum request dikirim, sisipkan token ke header Authorization
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor RESPONSE
// Tangani status 401 (token expired atau tidak valid)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Hapus semua data auth
      localStorage.clear();

      // Refresh halaman agar App / Router bisa mendeteksi kondisi logout
      window.location.reload();
    }

    return Promise.reject(error);
  }
);

export default api;
